import { memo, type ReactNode } from 'react'
import { X } from 'lucide-react'

interface Props {
  open: boolean
  title: string
  onClose: () => void
  children: ReactNode
}

export const LegalDialog = memo(function LegalDialog({ open, title, onClose, children }: Props) {
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="legal-title"
    >
      <button
        type="button"
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
        aria-label="Close"
      />
      <div className="relative z-10 flex max-h-[90dvh] w-full max-w-md flex-col rounded-xl border border-[#374151] bg-[#111827] shadow-xl">
        <div className="flex items-center justify-between border-b border-[#1f2937] px-5 py-3">
          <h2 id="legal-title" className="text-base font-semibold text-white">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-[#94a3b8] hover:bg-white/10 hover:text-white"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="space-y-3 overflow-y-auto px-5 py-4 text-xs leading-relaxed text-[#cbd5e1]">
          {children}
        </div>
      </div>
    </div>
  )
})
